import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cd6186c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "builds-table--cell-content"
}
const _hoisted_2 = {
  key: 1,
  class: "builds-table--cell"
}
const _hoisted_3 = {
  key: 0,
  class: "builds-table--cell-content"
}

import { computed } from 'vue';
import ColoredLeftBorder from '@/views/workloads/components/tableComponents/coloredLeftBorder.vue';
import { Builds_BuildResult } from '@/graphql/codegen/generated/graphql';
import { useWorkloadsColumnsManagement } from '@/views/workloads/components/navbarComponents/manageColumns/manage-columns.helpers';
import { useOsService } from '@/services/OsService/OsService';
import { WorkloadsTableColumns } from '@/views/workloads/workloads-table.types';


export default /*#__PURE__*/_defineComponent({
  __name: 'workloadsTableCell',
  props: {
    value: null,
    status: null,
    columnName: null
  },
  setup(__props: any) {

const props = __props as { value: unknown; status: Builds_BuildResult; columnName: WorkloadsTableColumns }

const osService = useOsService();
const tableData = useWorkloadsColumnsManagement();


const isFirstColumn = computed(() => tableData.tableColumns[osService.osType.value].value[0]?.name === props.columnName);

return (_ctx: any,_cache: any) => {
  return (_unref(isFirstColumn))
    ? (_openBlock(), _createBlock(ColoredLeftBorder, {
        key: 0,
        status: __props.status,
        class: "builds-table--cell"
      }, {
        default: _withCtx(() => [
          (__props.value !== undefined)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(__props.value), 1))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["status"]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        (__props.value !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(__props.value), 1))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "default")
      ]))
}
}

})